import { render, staticRenderFns } from "./FeeDetails.vue?vue&type=template&id=0fbab3fb&scoped=true&"
import script from "./FeeDetails.vue?vue&type=script&lang=js&"
export * from "./FeeDetails.vue?vue&type=script&lang=js&"
import style0 from "./FeeDetails.vue?vue&type=style&index=0&id=0fbab3fb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fbab3fb",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VContainer,VDataTable})
